export const BREAKPOINT_TABLET = 767;
export const BREAKPOINT_DESKTOP = 1023;
export const clickTrackingLoc = 'HQV AEM Page';
export const BRAND_LOGO_FONT_SIZE = '0px';
export const NON_BRANDED_ICON_FONT_SIZE = '22px';
